import { create } from 'zustand'

interface GalleryState {
  images: string[];
  setImages: (images: string[]) => void;
  clearGallery: () => void;
}

export const useGalleryStore = create<GalleryState>((set) => ({
  images: [],
  setImages: (images) => set({ images }),
  clearGallery: () => set({ images: [] }),
}))
